interface TryParseObject {
    str?: string
    undefinedOnError?: boolean
}

export const tryParseObject = (props: TryParseObject) => {
    const { str, undefinedOnError } = props
    try {
        if (!str) return str
        return JSON.parse(str)
    } catch (err: any) {
        if (undefinedOnError) return
        return str
    }
}interface TryParseObject {
    str?: string
    undefinedOnError?: boolean
}

export const tryParseObject = (props: TryParseObject) => {
    const { str, undefinedOnError } = props
    try {
        if (!str) return str
        return JSON.parse(str)
    } catch (err: any) {
        if (undefinedOnError) return
        return str
    }
}